import { IAction } from "../model/IAction";

export const REMOVE_GLOBAL_ERROR_HANDLER = "REMOVE_GLOBAL_ERROR_HANDLER";
export function removeGlobalErrorHandler(): RemoveElementAction {
    return {
        type: REMOVE_GLOBAL_ERROR_HANDLER,
        elementId: "globalErrorHandler"
    };
}

export interface RemoveElementAction extends IAction {
    elementId: string;
}
